import React from "react";

const SKELETON_ROWS = 6;

const PreviewTableSkeleton = ({ columns = 4, rows = SKELETON_ROWS }) => {
  const columnCount = Math.max(Number(columns) || 1, 1);
  const rowCount = Math.max(Number(rows) || 1, 1);

  return (
    <div
      className="preview-table-skeleton"
      style={{ "--column-count": columnCount }}
      role="status"
      aria-live="polite"
      aria-label="Loading preview"
    >
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <div key={rowIndex} className="preview-skeleton-row">
          {Array.from({ length: columnCount }).map((_, columnIndex) => (
            <span key={columnIndex} className="preview-skeleton-bar" />
          ))}
        </div>
      ))}
    </div>
  );
};

export default PreviewTableSkeleton;
